import { ShimmerElementType } from '@fluentui/react';
const { gap, line } = ShimmerElementType;
const messageGapHeight = 20;
const linkShimmer = [
    {
        type: line,
        width: '40%',
    },
    {
        type: gap,
        width: '60%',
    },
];
const messageShimmer = [
    // Line 1
    {
        type: line,
        width: '95%',
    },
    {
        height: messageGapHeight,
        type: gap,
        width: '5%',
    },
    // Line 2
    {
        type: line,
        width: '90%',
    },
    {
        height: messageGapHeight,
        type: gap,
        width: '10%',
    },
];
const reportIdShimmer = [
    {
        height: 14,
        type: line,
        width: '55%',
    },
    {
        type: gap,
        width: '45%',
    },
];
const titleShimmer = [
    {
        type: line,
        width: '60%',
    },
    {
        type: gap,
        width: '10%',
    },
    {
        type: line,
        width: '18%',
    },
    {
        type: gap,
        width: '6%',
    },
    {
        type: line,
        width: '6%',
    },
];
/**
 * Shimmer elements for the notifications card.
 *
 * The order in this array represents the visual order of the `shimmerElements`
 */
export const notificationCardShimmerElements = [
    ...titleShimmer,
    ...reportIdShimmer,
    ...messageShimmer,
    ...linkShimmer,
];
